import { IApiDataType } from '../types'
import { api as bbbApi } from './bbb'
import { api as commonApi } from './common'
import { api as fwWingstopApi } from './fw_wingstop'
import { api as wingitnorthApi } from './wingitnorth'

export type IApiKeyType = keyof typeof api

export const api = {
  ...commonApi,
  ...fwWingstopApi,
  ...bbbApi,
  ...wingitnorthApi,
}

const useApi = (apiName: IApiKeyType): IApiDataType => api[apiName]()

export default useApi
